import api from '../../api'
const recurrenceAPI = api.create('recurrence')

const get = async ({ contractId = '', ...params }) => {
  return await recurrenceAPI.get(`/contracts/${contractId}/entries`, { params })
}

const create = async ({ contractId = '', ...data }) => {
  return await recurrenceAPI.post(`/contracts/${contractId}/entries`, data)
}

const destroy = async ({ contractId, entryId }) => {
  return await recurrenceAPI.delete(
    `/contracts/${contractId}/entries/${entryId}`,
  )
}

export default { get, create, destroy }
